import { batch } from 'react-redux';
import { ForcedExchangeIsNotCompleted } from 'src/common/helpers/error-code';
import { TenderingActions } from 'src/common/redux/reducers/tendering-reducer';
import { handleForcedExchange } from 'src/force-exchange/business-logic/handle-forced-exchange';
import { store } from '../../common/redux/configure-store';
import { TransactionActions } from '../../common/redux/reducers/transaction-reducer';
import { applyCartResponse } from './common/apply-cart-response';
import { getPromotionApprovals } from './get-promotion-approvals';
import { ticketTotal } from './service/ticket-total';

export const getTicketTotal = async (): Promise<void> => {
  const transactionId = store.getState().transaction.transactionId;

  return ticketTotal(transactionId)
    .then(cartResponse =>
      applyCartResponse(cartResponse)
        .then(() => {
          const grandTotal = cartResponse.cartInfo?.totals?.netAmount || 0;
          batch((): void => {
            store.dispatch(TenderingActions.setGrandTotal(grandTotal));
            store.dispatch(TransactionActions.setIsTransactionalTotaled(true));
          });
        })
        // TODO: move this to PromotionAuthorizer
        .then(() => getPromotionApprovals(cartResponse)),
    )
    .catch(async err => {
      if (err.code === ForcedExchangeIsNotCompleted) {
        return handleForcedExchange(err.data);
      } else {
        throw err;
      }
    });
};
